export enum DialogType {
  Delete = 'delete',
  Edit = 'edit',
  Token = 'token',
}

export const MIN_PASSWORD_LENGTH = 12
export const HAS_LETTER = /[a-zA-Z]/
export const HAS_NUMBER = /\d/
export const HIDE_NEW_PASSWORD = 'Hide new password'
export const SHOW_NEW_PASSWORD = 'Show new password'
export const HIDE_CONFIRM_PASSWORD = 'Hide confirm password'
export const SHOW_CONFIRM_PASSWORD = 'Show confirm password'
export const PASSWORD_REQUIREMENTS =
  'Passwords must be at least 12 characters, and must contain at least one number and one letter.'
